import React, { useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import PieChart from 'components/PieChart/PieChart'
import { IReportFilter } from 'views/Reports'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import { AccentArea } from 'components'
/**
 * @name ByReasonCode
 * @desc Render % of Chargebacks by Reason Code (Top 5)
 * @filterValues IReportsFilter
 */
const ByReasonCode = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const { clientTheme } = useThemeStyling()
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<
        {
            name: string
            value: number
            tooltipName?: string
        }[]
    >([])

    React.useEffect(() => {
        setLoading(true)
        ReportsApi.getByReasonCode(filterValues).then((data) => {
            setLoading(false)
            setData(data)
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    const colorPalette = clientTheme.charts.pieCharts.defaultPieChart

    return (
        <AccentArea title="% of Chargebacks by Reason Code (Top 5)">
            <PieChart
                data={data}
                loading={loading}
                colorPalette={colorPalette}
                showLegend={true}
                testId="byReasonCodeTop5"
                height={425}
            />
        </AccentArea>
    )
}

export default ByReasonCode
